import { SelectionChangedEvent } from "ag-grid-community";
import { transferRowData } from "presentation/constant/AuditLog/AuditLogMaintenanceColumnDefinition";
import { INITIAL_LET_PASS_ACCOUNT_COL_DEF } from "presentation/constant/LetPassAccount/LetPassAccountColumnDefinition";
import { LetPassAccountConstant } from "presentation/constant/LetPassAccount/LetPassAccountConstant";
import { useLetPassAccountVM } from "presentation/hook/LetPassAccount/useLetPassAccountVM";
import { useLetPassAccountTracked } from "presentation/store/LetPassAccount/LetPassAccountProvider";
import { formatNumber } from "presentation/utils/numberUtil";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";

const LetPassAccountTablePanel: React.FC = () => {
    const [letPassAccountState] = useLetPassAccountTracked();
    const letPassAccountVM = useLetPassAccountVM();
    const { letPassAccountList, lpaBanlance } = letPassAccountState;
    const gridRef: any = useRef(null);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        letPassAccountVM.updateSelectedRows(selectedRows);
    }, [letPassAccountVM])

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='audit-log-table'
                isNewColumnSetting={true}
                columns={INITIAL_LET_PASS_ACCOUNT_COL_DEF}
                data={transferRowData(letPassAccountList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                rowSelection={"multiple"}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                headerLabel={LetPassAccountConstant.LPA_BALANCE + ": " + (lpaBanlance ? formatNumber(lpaBanlance, 2) : 0)}
            />
        );
    }, [handleSelectionChange, letPassAccountList, lpaBanlance])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(LetPassAccountTablePanel);
